export class ReportFilterModel {
    constructor(obj) {
        this.keyword = '';
        this.targets = [];
        this.recipients = [];
        this.period = { periodStart: '', periodEnd: '' };
        this.status = null;

        if (obj) {
            Object.assign(this, obj);
        }
    }
}
